export default "__VITE_ASSET__r_AvuaEm__"